let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9okqL")).then(() => parcelRequire('aV0eS'));